<div class="container-fluid">

  <h4 id="upper">Compte budgétaire</h4>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3 d-flex justify-content-between">
            <div class="col-auto">
              <a href="javascript:void(0);" class="btn btn-success mb-2" id="gras" (click)="openModal()">
                <i class="mdi mdi-plus me-2"></i> Ajouter un compte budgétaire
              </a>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-8">
              <div class="d-flex justify-content-end align-items-center gap-2 flex-nowrap">
                <label class="mb-0 text-nowrap">Chapitre</label>
                <select class="form-select form-select-sm" style="width: 220px;" [(ngModel)]="selectedChapitre"
                  (change)="loadSousChapitres()">
                  <option [ngValue]="null">Tous les chapitres</option>
                  <option *ngFor="let item of chapitres" [ngValue]="item.reference">
                    {{ item.code }} - {{ item.libelle }}
                  </option>
                </select>
                <label class="mb-0 text-nowrap">Sous-chapitre</label>
                <select class="form-select form-select-sm" style="width: 220px;" [(ngModel)]="selectedSousChapitre"
                  (change)="loadData()">
                  <option [ngValue]="null">Tous les sous-chapitres</option>
                  <option *ngFor="let item of sousChapitres" [ngValue]="item.reference">
                    {{ item.code }} - {{ item.libelle }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light rwd-table">
                <tr>
                  <th style="width: 20px;"></th>
                  <th>Code</th>
                  <th>Compte budgétaire</th>
                  <th>Sous-chapitre</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedProjets; let i = index">
                  <td></td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.libelle }}</td>
                  <td>{{ item.sous_chapitre?.libelle }}</td>
                  <td>
                    <a (click)="openModal(item)" style="cursor: pointer;" class="me-3 text-primary">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a (click)="confirmSuppression(item)" href="javascript:void(0);" class="text-danger">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center" *ngIf="!isLoading">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h6 id="graycolor">chargement en cours</h6>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="paginatedProjets.length === 0 && isLoading" class="d-flex justify-content-center">
            <h5 id="graycolor">Aucun compte budgétaire trouvé</h5>
          </div>

          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #compteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ item.reference ? 'Modifier' : 'Ajouter' }} un compte budgétaire</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <form>
      <div class="row mb-3">
        <div class="form-group col-md-12">
          <label>Chapitre <span class="text-danger">*</span></label>
          <select name="modalChapitre" class="form-select" [(ngModel)]="modalChapitre" (change)="onModalChapitreChange()">
            <option [ngValue]="null">Sélectionner un chapitre</option>
            <option *ngFor="let ch of chapitres" [ngValue]="ch.reference">
              {{ ch.code }} - {{ ch.libelle }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mb-3">
        <div class="form-group col-md-12">
          <label>Sous-chapitre <span class="text-danger">*</span></label>
          <select name="sous_chapitre_id" class="form-select" [(ngModel)]="item.sous_chapitre_id" (change)="onParentChange()">
            <option [ngValue]="null">Sélectionner un sous-chapitre</option>
            <option *ngFor="let item of modalSousChapitres" [ngValue]="item.reference">
              {{ item.code }} - {{ item.libelle }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mb-3">
        <div class="form-group col-md-3">
          <label>Code <span class="text-danger">*</span></label>
          <input [(ngModel)]="item.code" name="code" type="text" class="form-control">
        </div>
        <div class="form-group col-md-9">
          <label>Compte budgétaire <span class="text-danger">*</span></label>
          <input [(ngModel)]="item.libelle" name="libelle" type="text" class="form-control">
        </div>
      </div>
      <div class="text-end mt-3">
        <button (click)="modal.close()" type="button" class="btn btn-light ms-1">
          <i class="pi pi-times" style="color: #212529"></i> Annuler
        </button>&nbsp;
        <button (click)="save()" type="button" class="btn btn-success">
          <i class="pi pi-save" style="color: white"></i> Enregistrer
        </button>
      </div>
    </form>
  </div>
</ng-template>

<p-confirmDialog></p-confirmDialog>
<p-toast position="center"></p-toast>
<ngx-ui-loader></ngx-ui-loader>
